export default __webpack_public_path__ + "static/secondary-year-e353c69942f8ee50ae8a00d4b7b74514.jpg";